export default "__VITE_ASSET__Dk3Y1ODM__"